module.exports = __webpack_public_path__ + "static/media/battery-slash.256c7501.svg";